module.exports = __webpack_public_path__ + "img/graph.65967c09.svg";